module.exports = __webpack_public_path__ + "static/media/img3.309140ba.jpg";